module.exports = __webpack_public_path__ + "media/images/pub/header_bkg-2a2636625de581a58343dff518900b36.jpg";